module.exports = __webpack_public_path__ + "img/0Q3B1891_L_Black.6458af6a.jpg";